import { Modal } from '@/components/Modal';

import type { RichContent } from '@/types/content';

interface RoomImagesModalProps {
  media: RichContent[];
  showModal: boolean;
  closeModal: () => void;
}

export function RoomImagesModal({ media, showModal, closeModal }: RoomImagesModalProps) {
  return (
    <Modal show={showModal} onClose={closeModal}>
      {media.map((content) => (
        <img key={content.id} src={content.path} alt="Hotel room" />
      ))}
    </Modal>
  );
}
